import { Badge } from '@/components/ui/badge';

type Variant = React.ComponentProps<typeof Badge>['variant'];

const PAYMENT_VARIANT: Record<string, Variant> = {
  pending: 'secondary',
  requires_action: 'warning',
  processing: 'secondary',
  succeeded: 'success',
  failed: 'destructive',
  expired: 'outline',
  refunded: 'outline',
};

const DELIVERY_VARIANT: Record<string, Variant> = {
  pending: 'secondary',
  delivered: 'success',
  retrying: 'warning',
  dlq: 'destructive',
  resolved: 'outline',
};

export function PaymentStatusBadge({ status }: { status: string }) {
  return <Badge variant={PAYMENT_VARIANT[status] ?? 'outline'}>{status}</Badge>;
}

export function DeliveryStatusBadge({ status }: { status: string }) {
  return <Badge variant={DELIVERY_VARIANT[status] ?? 'outline'}>{status}</Badge>;
}
